import { render, staticRenderFns } from "./TimeGather.vue?vue&type=template&id=64ea956f&scoped=true&"
import script from "./TimeGather.vue?vue&type=script&lang=js&"
export * from "./TimeGather.vue?vue&type=script&lang=js&"
import style0 from "./TimeGather.vue?vue&type=style&index=0&id=64ea956f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ea956f",
  null
  
)

export default component.exports